<template>
  <v-app>
    <v-main class="gastronomie-page">

      <section class="gastronomie-hero">

        <!-- =====================================================
             HINTERGRUNDBILD
        ====================================================== -->

        <img
          :src="GastroBg"
          alt="Professionelle Gastronomieküche"
          class="hero-image"
        />

        <!-- =====================================================
             WEISSER VERLAUF
        ====================================================== -->

        <div class="hero-gradient"></div>

        <!-- =====================================================
             HERO TEXT
        ====================================================== -->

        <div class="hero-content">

      

          <h1>
            Gastronomie
          </h1>

          <div class="green-line"></div>

          <h2>
            Hygiene, die im Alltag funktioniert.
          </h2>

          <p>
            Wir unterstützen gastronomische Betriebe mit<br class="desktop-only">
            praxisnahen Lösungen, die Sicherheit schaffen,<br class="desktop-only">
            Abläufe erleichtern und im täglichen Betrieb<br class="desktop-only">
            wirklich umsetzbar sind.
          </p>

        </div>


        <!-- =====================================================
             USP BEREICH
        ====================================================== -->

        <div class="usp-panel">

          <!-- =================================================
               SICHERHEIT
          ================================================== -->

          <div class="usp-item">

            <div class="usp-icon">

              <v-icon size="42">
                mdi-shield-check-outline
              </v-icon>

            </div>

            <h3>
              Sicherheit
            </h3>

            <p>
              Klare und verständliche<br class="desktop-only">
              Abläufe schaffen Sicherheit<br class="desktop-only">
              im täglichen Betrieb.
            </p>

          </div>


          <!-- =================================================
               TEAM
          ================================================== -->

          <div class="usp-item">

            <div class="usp-icon">

              <v-icon size="42">
                mdi-account-group-outline
              </v-icon>

            </div>

            <h3>
              Team
            </h3>

            <p>
              Hygiene funktioniert nur dann<br class="desktop-only">
              nachhaltig, wenn sie von allen<br class="desktop-only">
              verstanden und umgesetzt wird.
            </p>

          </div>


          <!-- =================================================
               PRAXIS
          ================================================== -->

          <div class="usp-item">

            <div class="usp-icon">

              <v-icon size="42">
                mdi-bullseye-arrow
              </v-icon>

            </div>

            <h3>
              Praxis
            </h3>

            <p>
              Unsere Lösungen orientieren<br class="desktop-only">
              sich an den tatsächlichen<br class="desktop-only">
              Abläufen Ihres Betriebes.
            </p>

          </div>

        </div>

      </section>

    </v-main>
  </v-app>
</template>


<script setup>

import GastroBg from '../assets/GastroBg.png'

</script>


<style scoped>

/* ============================================================
   GRUNDLAYOUT
============================================================ */

.gastronomie-page {
  width: 100%;
  min-height: 100vh;

  background: #ffffff;

  color: #17191c;

  overflow-x: hidden;
}


/* ============================================================
   HERO
============================================================ */

.gastronomie-hero {
  position: relative;

  width: 100%;

  min-height: 900px;

  overflow: hidden;

  background: #f5f5f3;
}


/* ============================================================
   HINTERGRUNDBILD
============================================================ */

.hero-image {
  position: absolute;

  inset: 0;

  width: 100%;
  height: 100%;

  display: block;

  object-fit: cover;

  object-position: center center;

  z-index: 0;
}


/* ============================================================
   WEISSER VERLAUF
============================================================ */

.hero-gradient {
  position: absolute;

  inset: 0;

  z-index: 1;

  pointer-events: none;

  background:
    linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.98) 0%,
      rgba(255, 255, 255, 0.96) 18%,
      rgba(255, 255, 255, 0.88) 31%,
      rgba(255, 255, 255, 0.58) 42%,
      rgba(255, 255, 255, 0.18) 56%,
      rgba(255, 255, 255, 0) 72%
    );
}


/* ============================================================
   HERO CONTENT
============================================================ */

.hero-content {
  position: relative;

  z-index: 5;

  width: min(760px, calc(100% - 100px));

  margin-left: max(
    85px,
    calc((100% - 1500px) / 2)
  );

  padding-top: 105px;

  padding-bottom: 80px;

  box-sizing: border-box;
}


/* ============================================================
   BRAND
============================================================ */

.hero-brand {
  margin-bottom: 18px;

  color: #202328;

  font-size: 15px;

  line-height: 1;

  font-weight: 500;

  letter-spacing: 5px;
}


/* ============================================================
   HAUPTÜBERSCHRIFT
============================================================ */

.hero-content h1 {
  margin: 0;

  color: #202328;

  font-size: clamp(
    58px,
    5.4vw,
    96px
  );

  line-height: 0.98;

  font-weight: 750;

  letter-spacing: -3px;
}


/* ============================================================
   GRÜNE LINIE
============================================================ */

.green-line {
  width: 132px;

  height: 6px;

  margin-top: 27px;

  margin-bottom: 32px;

  border-radius: 20px;

  background: #72b82a;
}


/* ============================================================
   SUBTITLE
============================================================ */

.hero-content h2 {
  margin: 0 0 20px;

  color: #202328;

  font-size: clamp(
    27px,
    2.25vw,
    39px
  );

  line-height: 1.15;

  font-weight: 700;

  letter-spacing: -0.8px;
}


/* ============================================================
   BESCHREIBUNG
============================================================ */

.hero-content p {
  margin: 0;

  color: #30343a;

  font-size: clamp(
    18px,
    1.35vw,
    24px
  );

  line-height: 1.55;

  font-weight: 400;
}


/* ============================================================
   USP PANEL
============================================================ */

.usp-panel {
  position: absolute;

  left: 4%;
  right: 4%;

  bottom: 0;

  z-index: 10;

  height: 285px;

  padding: 52px 5% 35px;

  display: grid;

  grid-template-columns: repeat(
    3,
    1fr
  );

  box-sizing: border-box;

  border-radius:
    52% 52% 0 0 /
    12% 12% 0 0;

  background:
    rgba(
      255,
      255,
      255,
      0.96
    );

  box-shadow:
    0 -8px 30px
    rgba(
      0,
      0,
      0,
      0.03
    );
}


/* ============================================================
   USP ITEM
============================================================ */

.usp-item {
  position: relative;

  min-height: 185px;

  padding: 0 55px;

  display: flex;

  flex-direction: column;

  align-items: center;

  justify-content: flex-start;

  text-align: center;

  box-sizing: border-box;
}


/* ============================================================
   USP TRENNLINIEN
============================================================ */

.usp-item:not(:last-child)::after {
  content: "";

  position: absolute;

  top: 8px;

  right: 0;

  width: 1px;

  height: 170px;

  background: #e2e2e2;
}


/* ============================================================
   USP ICON
============================================================ */

.usp-icon {
  width: 102px;
  height: 102px;

  margin-bottom: 13px;

  display: flex;

  align-items: center;

  justify-content: center;

  border-radius: 50%;

  background:
    rgba(
      114,
      184,
      42,
      0.12
    );

  color: #72b82a;
}


.usp-icon .v-icon {
  color: #72b82a;
}


/* ============================================================
   USP ÜBERSCHRIFT
============================================================ */

.usp-item h3 {
  margin: 0 0 8px;

  color: #202328;

  font-size: 25px;

  line-height: 1.1;

  font-weight: 700;
}


/* ============================================================
   USP TEXT
============================================================ */

.usp-item p {
  margin: 0;

  color: #363a40;

  font-size: 17px;

  line-height: 1.4;
}


/* ============================================================
   TABLET
============================================================ */

@media (max-width: 1100px) {

  .gastronomie-hero {
    min-height: 850px;
  }


  .hero-content {
    width: calc(100% - 100px);

    margin-left: 50px;

    padding-top: 80px;

    padding-bottom: 70px;
  }


  .hero-content h1 {
    font-size: 72px;
  }


  .hero-content h2 {
    font-size: 30px;
  }


  .hero-content p {
    font-size: 17px;
  }


  .usp-panel {

    left: 2%;
    right: 2%;

    height: 250px;

    padding-left: 2%;
    padding-right: 2%;
  }


  .usp-item {
    padding: 0 25px;
  }


  .usp-item h3 {
    font-size: 21px;
  }


  .usp-item p {
    font-size: 14px;
  }

}


/* ============================================================
   MOBILE
============================================================ */

@media (max-width: 760px) {

  /* ----------------------------------------------------------
     SEITENBREITE
  ---------------------------------------------------------- */

  .gastronomie-page {
    width: 100%;
    max-width: 100%;

    overflow-x: hidden;
  }


  .gastronomie-hero {
    width: 100%;
    min-height: 0;

    padding: 0;

    overflow: hidden;

    background: #ffffff;
  }


  /* ----------------------------------------------------------
     MOBILE BILD
  ---------------------------------------------------------- */

  .hero-image {

    position: relative;

    inset: auto;

    width: 100%;
    max-width: 100%;

    height: 260px;

    display: block;

    object-fit: cover;

    object-position: center center;
  }


  /* ----------------------------------------------------------
     MOBILE VERLAUF
  ---------------------------------------------------------- */

  .hero-gradient {

    position: absolute;

    top: 0;
    left: 0;
    right: 0;

    height: 260px;

    background:
      linear-gradient(
        180deg,
        rgba(255,255,255,0) 0%,
        rgba(255,255,255,0.02) 45%,
        rgba(255,255,255,0.45) 75%,
        rgba(255,255,255,0.95) 100%
      );
  }


  /* ----------------------------------------------------------
     MOBILE HERO TEXT
  ---------------------------------------------------------- */

  .hero-content {

    position: relative;

    width: calc(100% - 28px);

    max-width: none;

    margin: 0 auto;

    padding:
      28px
      0
      35px;

    background: #ffffff;

    box-sizing: border-box;

    overflow: hidden;
  }


  /* ----------------------------------------------------------
     BRAND
  ---------------------------------------------------------- */

  .hero-brand {

    margin-bottom: 14px;

    font-size: 10px;

    line-height: 1.2;

    letter-spacing: 3px;

    white-space: nowrap;
  }


  /* ----------------------------------------------------------
     HAUPTÜBERSCHRIFT
  ---------------------------------------------------------- */

  .hero-content h1 {

    width: 100%;

    max-width: 100%;

    margin: 0;

    font-size: 40px;

    line-height: 1.02;

    letter-spacing: -1.6px;

    white-space: normal;

    overflow-wrap: normal;

    word-break: normal;
  }


  /* ----------------------------------------------------------
     GRÜNE LINIE
  ---------------------------------------------------------- */

  .green-line {

    width: 75px;

    height: 4px;

    margin-top: 17px;

    margin-bottom: 21px;
  }


  /* ----------------------------------------------------------
     SUBTITLE
  ---------------------------------------------------------- */

  .hero-content h2 {

    width: 100%;

    margin: 0 0 16px;

    font-size: 23px;

    line-height: 1.2;

    letter-spacing: -0.3px;
  }


  /* ----------------------------------------------------------
     BESCHREIBUNG
  ---------------------------------------------------------- */

  .hero-content p {

    width: 100%;

    margin: 0;

    font-size: 16px;

    line-height: 1.55;

    color: #30343a;
  }


  /* ----------------------------------------------------------
     DESKTOP ZEILENUMBRÜCHE AUSBLENDEN
  ---------------------------------------------------------- */

  .desktop-only {
    display: none;
  }


  /* ----------------------------------------------------------
     MOBILE USP
  ---------------------------------------------------------- */

  .usp-panel {

    position: relative;

    left: auto;
    right: auto;
    bottom: auto;

    width: calc(100% - 28px);

    max-width: none;

    height: auto;

    min-height: 0;

    margin:
      0 auto 20px;

    padding:
      8px 10px;

    display: grid;

    grid-template-columns: 1fr;

    box-sizing: border-box;

    border-radius: 25px;

    background: #ffffff;

    box-shadow:
      0 4px 20px
      rgba(
        0,
        0,
        0,
        0.08
      );
  }


  /* ----------------------------------------------------------
     MOBILE USP ITEM
  ---------------------------------------------------------- */

  .usp-item {

    min-height: 0;

    padding:
      24px 15px;

    border-bottom:
      1px solid #e3e3e3;
  }


  .usp-item:last-child {
    border-bottom: none;
  }


  .usp-item:not(:last-child)::after {
    display: none;
  }


  /* ----------------------------------------------------------
     MOBILE ICON
  ---------------------------------------------------------- */

  .usp-icon {

    width: 82px;
    height: 82px;

    margin-bottom: 11px;
  }


  .usp-icon .v-icon {

    font-size:
      35px !important;
  }


  /* ----------------------------------------------------------
     MOBILE USP HEADLINE
  ---------------------------------------------------------- */

  .usp-item h3 {

    margin: 0 0 7px;

    font-size: 22px;

    line-height: 1.15;
  }


  /* ----------------------------------------------------------
     MOBILE USP TEXT
  ---------------------------------------------------------- */

  .usp-item p {

    margin: 0;

    font-size: 14px;

    line-height: 1.5;
  }

}


/* ============================================================
   SEHR KLEINE GERÄTE
============================================================ */

@media (max-width: 430px) {

  .hero-image {

    height: 235px;
  }


  .hero-gradient {

    height: 235px;
  }


  .hero-content {

    width: calc(100% - 26px);

    padding:
      24px
      0
      30px;
  }


  .hero-brand {

    font-size: 9px;

    letter-spacing: 2.7px;

    margin-bottom: 12px;
  }


  .hero-content h1 {

    font-size: 38px;

    line-height: 1;

    letter-spacing: -1.5px;
  }


  .green-line {

    width: 72px;

    height: 4px;

    margin-top: 16px;

    margin-bottom: 19px;
  }


  .hero-content h2 {

    font-size: 21px;

    line-height: 1.2;

    margin-bottom: 15px;
  }


  .hero-content p {

    font-size: 15px;

    line-height: 1.55;
  }


  .usp-panel {

    width: calc(100% - 20px);

    margin-bottom: 15px;

    border-radius: 22px;
  }


  .usp-item {

    min-height: 0;

    padding:
      23px 12px;
  }


  .usp-icon {

    width: 76px;
    height: 76px;

    margin-bottom: 10px;
  }


  .usp-icon .v-icon {

    font-size:
      33px !important;
  }


  .usp-item h3 {

    font-size: 21px;
  }


  .usp-item p {

    font-size: 14px;

    line-height: 1.5;
  }

}


/* ============================================================
   SEHR SCHMALE SMARTPHONES
============================================================ */

@media (max-width: 360px) {

  .hero-image {
    height: 215px;
  }


  .hero-gradient {
    height: 215px;
  }


  .hero-content {

    width: calc(100% - 22px);

    padding-top: 21px;
  }


  .hero-brand {

    font-size: 8px;

    letter-spacing: 2.4px;
  }


  .hero-content h1 {

    font-size: 34px;

    letter-spacing: -1.2px;
  }


  .hero-content h2 {

    font-size: 19px;

    line-height: 1.22;
  }


  .hero-content p {

    font-size: 14px;
  }


  .usp-panel {

    width: calc(100% - 16px);
  }


  .usp-item {

    padding-left: 8px;
    padding-right: 8px;
  }

}

</style>